import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmCustomQueueBoardRoute: InvariantJiraRoute = {
	name: 'csm-queues-custom-board',
	path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId/board/:boardId',
	exact: true,
};
